// Cálculo de intereses (mora) y descuentos (pronto pago). Funciones puras, sin React.
// Descuento: categoría con tasa fija (Abono 5%, Químico/Semilla 6%), IVA incluido.
// Mora: la tasa la carga el usuario (general o por fila); interés = valor × tasa × días/365 + IVA 10%.
// En mora, un pago ANTICIPADO (días negativos) resta como crédito a la tasa de su categoría, IVA incluido.
export const CATS = { "Abono/Fertilizante": 5, "Químico": 6, "Semilla": 6 };
// Categorías de interés: no tienen tasa fija (la tasa de mora es manual) ni dan crédito por adelanto.
export const CATS_INTERES = ["Interés por deuda", "Interés por préstamo"];
export const esCatInteres = (c) => CATS_INTERES.includes(c);
// Grupo para separar en el PDF.
export const grupoDe = (c) => (c === "Interés por préstamo" ? "Interés por préstamo" : c === "Interés por deuda" ? "Interés por deuda" : "Deuda comercial");
export const catValida = (c) => (CATS[c] || esCatInteres(c) ? c : c === "Interés" ? "Interés por deuda" : "Químico");

export const parseNum = (v) => parseFloat(String(v ?? "").replace(/\./g, "").replace(",", ".")) || 0;

const diasEntre = (desde, hasta) => Math.round((new Date(hasta) - new Date(desde)) / 86400000);

export function calcRow(r, tasaGeneral, modo, fechaCorte) {
  const vp = parseNum(r.valorPago);
  const empty = { dias: 0, tipo: "—", tasa: 0, base: 0, iva: 0, total: 0, interes: 0, descuento: 0, abierto: false, fecha: "" };
  if (modo === "interes") {
    const abierto = !!r.saldoCorr || !r.fechaPago; // saldo corregido: se calcula hasta la fecha indicada (o la de corte)
    const fecha = r.fechaPago || fechaCorte;
    if (!r.vto || !fecha || !vp) return empty;
    const dias = diasEntre(r.vto, fecha);
    const res = { ...empty, abierto, fecha, dias };
    if (dias > 0) {
      const tasa = parseFloat(r.tasaManual) || parseFloat(tasaGeneral) || 0;
      const base = vp * (tasa / 100) * (dias / 365);
      const iva = base * 0.10;
      return { ...res, tipo: "Interés", tasa, base, iva, total: base + iva, interes: base + iva };
    }
    if (dias < 0 && !esCatInteres(r.categoria)) {
      // pago anticipado: crédito con IVA incluido (no se suma IVA)
      const tasa = CATS[r.categoria] || 6;
      const base = vp * (tasa / 100) * (-dias / 365);
      return { ...res, tipo: "Adelanto", tasa, base, iva: 0, total: -base, interes: -base };
    }
    return res;
  }
  if (!r.vto || !r.fechaPago || !vp) return empty;
  const dias = -diasEntre(r.vto, r.fechaPago);
  if (dias <= 0) return { ...empty, dias: Math.max(dias, 0) };
  const tasa = parseFloat(r.tasaManual) || CATS[r.categoria] || 6;
  const base = vp * (tasa / 100) * (dias / 365);
  return { dias, tipo: "Descuento", tasa, base, iva: 0, total: base, interes: 0, descuento: base, abierto: false, fecha: r.fechaPago };
}

// Resumen de mora: pagado, saldo abierto, interés por mora, crédito por adelanto, neto y total a pagar al corte.
export function resumenMora(computed) {
  const o = { pagado: 0, saldo: 0, mora: 0, credito: 0, iva: 0 };
  computed.forEach(({ r, c }) => {
    const vp = parseNum(r.valorPago);
    if (c.abierto) o.saldo += vp; else o.pagado += vp;
    if (c.interes > 0) o.mora += c.interes;
    if (c.interes < 0) o.credito += -c.interes;
    o.iva += c.iva;
  });
  o.neto = o.mora - o.credito;
  o.total = o.saldo + o.neto;
  return o;
}
